import React from 'react';
import { Dropdown } from 'antd';
import PropTypes from 'prop-types';

export default function dropdown(props) {
  const { children } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Dropdown {...props}>
      {children}
    </Dropdown>
  );
}
dropdown.defaultProps = {
  children: ''
};
dropdown.propTypes = {
  children: PropTypes.objectOf(PropTypes.any)
};

dropdown.displayName = 'Dropdown';
